import { useMemo } from "react";

export const useSearchQuery = (search: string) => {
  return useMemo(() => new URLSearchParams(search), [search]);
};
